// client/src/components/Home.jsx
import React, { useEffect, useRef } from 'react';
import '../styles/Room.css';

const Home = ({
  roomId,
  setRoomId,
  nickname,
  setNickname,
  setJoined,
  localStream,
  setLocalStream,
  audioEnabled,
  setAudioEnabled,
  videoEnabled,
  setVideoEnabled,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    const initLocalStream = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: { width: 854, height: 480, frameRate: {min:10, max:24 }}, // 480p resolution at 20fps
        });
        setLocalStream(stream);
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          console.log("Video pixels: ",videoRef.current.srcObject.getVideoTracks()[0].getSettings()); // Log video track settings
        }
      } catch (err) {
        console.error('Error accessing media devices:', err);
      }
    };

    initLocalStream();

    return () => {
      if (localStream) {
        localStream.getTracks().forEach(track => track.stop());
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleAudio = () => {
    if (localStream) {
      const audioTrack = localStream.getAudioTracks()[0];
      if (audioTrack) {
        audioTrack.enabled = !audioTrack.enabled;
        setAudioEnabled(audioTrack.enabled);
      }
    }
  };

  const toggleVideo = () => {
    if (localStream) {
      const videoTrack = localStream.getVideoTracks()[0];
      if (videoTrack) {
        videoTrack.enabled = !videoTrack.enabled;
        setVideoEnabled(videoTrack.enabled);
      }
    }
  };

  const handleJoin = () => {
    if (roomId && nickname) {
      setJoined(true);
    }
  };

  return (
    <div className="home-container">
      <h1>Join Meeting</h1>
      <div className="home-contents">
        <div>
          <div>

            <input
              type="text"
              value={roomId}
              id="roomid"
              name="roomid"
              onChange={(e) => setRoomId(e.target.value.toUpperCase())}
              placeholder="Enter room ID"
            />
          </div>
          <div>
            <input
              type="text"
              id="name"
              name="name"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              placeholder="Enter your Name"
            />
          </div>
        </div>
        <div className="preview-container">
          <div className="video-preview">
            <video ref={videoRef} autoPlay playsInline muted />
          </div>
          <div className="controls">
            <button onClick={toggleAudio} className={`control-button ${audioEnabled ? 'active' : 'inactive'}`}>
              {audioEnabled ? 'Mute' : 'Unmute'}
            </button>
            <button onClick={toggleVideo} className={`control-button ${videoEnabled ? 'active' : 'inactive'}`}>
              {videoEnabled ? 'Stop Video' : 'Start Video'}
            </button>
          </div>
        </div>
      </div>
      <div>
        <button onClick={handleJoin} className="join-button">
          Ready To Join ?
        </button>
      </div>
    </div>
  );
};

export default Home;